import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <Svg width="121" height="120" viewBox="0 0 121 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.5595 100.318C53.5595 103.456 56.891 106 61.0007 106C65.1103 106 68.4419 103.456 68.4419 100.318L68.4419 37.7728L96.8052 66.1361C99.447 68.7779 103.73 68.7779 106.372 66.1361C109.014 63.4943 109.014 59.2111 106.372 56.5693L65.7835 15.9808C64.5149 14.7122 62.7942 13.9995 61.0001 13.9995C59.206 13.9995 57.4853 14.7122 56.2167 15.9808L15.6282 56.5693C12.9864 59.2111 12.9864 63.4943 15.6282 66.1361C18.27 68.7779 22.5532 68.7779 25.195 66.1361L53.5595 37.7717L53.5595 100.318Z"
        fill="#2E81FF"
      />
    </Svg>
  );
};

export default Icon;
